import { render, staticRenderFns } from "./RedirectSection.vue?vue&type=template&id=4152405a&"
import script from "./RedirectSection.vue?vue&type=script&lang=js&"
export * from "./RedirectSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports